import { hasBoneAt } from "./index20.js";
import { BoneSide } from "@project-rouge/rg-core";
function hasCornerCore(props) {
	if ("start" in props) return doesBoneHaveCornerCore(props);
	const joint = props;
	return doesBoneHaveCornerCore({
		bone: joint.bones[0],
		start: joint.bones[0].joints[0] === joint
	});
}
function doesBoneHaveCornerCore({ bone, right, start }) {
	if (right === void 0) return doesBoneHaveCornerCore({
		bone,
		start,
		right: true
	}) || doesBoneHaveCornerCore({
		bone,
		start,
		right: false
	});
	return bone.loads[right ? BoneSide.Right : BoneSide.Left] && hasBoneAt({
		bone,
		right,
		start,
		innerLoad: true
	});
}
export { hasCornerCore };

//# sourceMappingURL=index22.js.map